import { useEffect } from "react";
import { useFilterState } from "../../hooks/useFilterState";

interface UseFilterParams {
  isTrashView: boolean;
  searchData: (query: string) => void;
  clearSearch: () => void;
}

export const useFilter = ({ isTrashView, searchData, clearSearch }: UseFilterParams) => {
  const filterState = useFilterState({
    searchData,
    clearSearch,
    storageKey: 'confirmPage',
  });

  const { setPropertyFilter, setRoomFilter, setLesseeFilter } = filterState;

  // ConfirmPage 固有: ゴミ箱表示に切り替えたときのみフィルターをクリア
  useEffect(() => {
    if (isTrashView) {
      if (filterState.propertyFilter !== "" || filterState.roomFilter !== "" || filterState.lesseeFilter !== "") {
        setPropertyFilter("");
        setRoomFilter("");
        setLesseeFilter("");
      }
    }
  }, [isTrashView, setPropertyFilter, setRoomFilter, setLesseeFilter, filterState.propertyFilter, filterState.roomFilter, filterState.lesseeFilter]);

  return filterState;
};
